/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ListTitles } from 'src/app/services/constants';
import { DocumentLibraryService } from 'src/app/services/document-library.service';
import { ErrorService } from 'src/app/services/error.service';
import { ReferenceData } from 'src/app/services/models';
import { ReferenceDataService } from 'src/app/services/reference-data.service';
import { SearchService } from 'src/app/services/search.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import { sort, SortDirection } from 'src/app/services/utils';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DocumentProperty } from '../documents-list.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html'
})
export class AddDocumentComponent implements OnInit {
  linkAddress: string;
  referenceData: ReferenceData;
  filesToUpload: File[];
  allKeyWords: string[] = [];
  verifiedKeyWords: string[] = [];
  selectedKeywords: string[] = [];
  newKeywords: string[] = [];
  isUploadingDocument = false;
  controlSubmitButton = true;
  @Input() isLinkAllowed = false;
  @Input() libraryName: string;
  @Input() title = 'Upload Guidance';
  @Input() documentProperties: DocumentProperty[] = [];
  @Input() fileNameTreatment: boolean = false;
  @Output() refreshDocuments = new EventEmitter<boolean>();
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  docItem: any = {};
  
  id:any;
  sortOrder:number;
  get isLinkDisabled(): boolean {
    return this.filesToUpload !== undefined && this.filesToUpload.length > 0;
  }

  get isUploadFileDisabled(): boolean {
    return this.linkAddress?.length > 0;
  }

  constructor(public searchService: SearchService,
              public sidebar: SideBarService,
              private referenceDataService: ReferenceDataService,
              private errorService: ErrorService,
              private documentLibraryService: DocumentLibraryService,
              private confirmationDialogService: ConfirmationDialogService,
              private route: ActivatedRoute,)
               {
                this.route.paramMap.subscribe(params => {
                  this.id = params.get('id');
                });
               }



  async ngOnInit(): Promise<void> {
    if(this.libraryName === ListTitles.AEMGuidanceDocuments) this.controlSubmitButton = false;
    const referenceDataPromise = this.referenceDataService.get();
    const HtaKeywordsPromise = this.referenceDataService.getHtaKeywords()

    try {
      this.referenceData = await referenceDataPromise;
      if(this.referenceData && this.referenceData.CollateralTypes) {
        sort(this.referenceData.CollateralTypes, 'Title', SortDirection.Ascending);
      }
    }
    catch(error) {
      this.errorService.show('Failed to get reference data', error);
    }

    try {
       const keywords = await HtaKeywordsPromise;
       sort(keywords, 'Title', SortDirection.Ascending);
       this.verifiedKeyWords = keywords.map(x => x.Title);
    }
    catch(error) {
      this.errorService.show('Failed to get keywords', error);
    }

    this.allKeyWords = this.verifiedKeyWords;
    this.selectedKeywords = [];
    this.newKeywords = [];
    this.filesToUpload = [];
  }

  selectFile(): void {
    if(!this.isUploadingDocument){
      this.fileInput.nativeElement.value="";
      this.fileInput.nativeElement.click();
    }
  }

  addKeyword(keyword: string): void {
    if(!this.verifiedKeyWords.includes(keyword) && !this.newKeywords.includes(keyword)) {
      this.newKeywords.push(keyword);
    }
  }

  removeKeyword(keyword: any): void {
    if(this.newKeywords.includes(keyword.value)) {
      this.newKeywords.splice(this.newKeywords.findIndex( x => x == keyword.value), 1);
    }
  }

  clearKeywords(): void {
    this.newKeywords = [];
  }

  private get keywords(): string {
    if(this.selectedKeywords && this.selectedKeywords.length > 0) {
      return this.selectedKeywords.join(', ');
    }
    return undefined;
  }

  async submitDocument(): Promise<void> {
    this.isUploadingDocument = this.filesToUpload?.length > 0 || this.linkAddress?.length > 0;
    if(!this.controlSubmitButton && !this.isUploadingDocument) {
      await this.confirmationDialogService.confirm('Alert!',
      'Please select a file',
      'Ok', null, 'sm');
      return;
    }

    if (!this.isUploadingDocument) return;
    try {
      let file: File;
      let fileName: string;
      let title: string;
      if (this.linkAddress?.length > 0) {
        file = this.documentLibraryService.generateLinkFile(this.linkAddress, true);
        fileName = file.name;
        title = this.linkAddress;
      }
      else {
        file = this.filesToUpload[0];
        title = fileName = file.name;
        if(this.fileNameTreatment === true) {
          let docType = "";
          const splittedFileName = this.filesToUpload[0].name.split(".");
          const uuidv4 = `_${Math.floor(Math.random() * (1257))}`;
          if (splittedFileName.length > 0) docType = splittedFileName.pop();
          fileName = splittedFileName[0].replace(/[^a-zA-Z0-9]/g, '').trim() + uuidv4 + "." + docType;
        }
      }

      const docProps: any = {};
      docProps.Title = title;
      this.documentProperties.forEach(p => {
        if (p.type === 'Keywords') {
          const keywords = this.keywords;
          if (keywords) docProps[p.name] = keywords;
        }
        else {
          const propValue = this.docItem[p.name];
          if (propValue != null && propValue !== '') docProps[p.name] = propValue;
        }
      });
      if(this.libraryName != 'AccessTrends-Resources'){
        await this.documentLibraryService.addDocument(this.libraryName, file, true, docProps, fileName);
      }
      else{
        await this.documentLibraryService.addTrendsDocumentWithId(this.sortOrder,this.id,this.libraryName, file, true, docProps, fileName);
      }
      
     
    }
    catch (error) {
      this.errorService.show(`Failed to upload document`, error);
    }
    try {
      if (this.newKeywords && this.newKeywords.length > 0) {
        await this.documentLibraryService.addHtaKeywords(this.newKeywords);
      }
    }
    catch (error) {
      this.errorService.show(`Failed to save new keywords for ${this.title}`, error);
    }
    this.isUploadingDocument = false;
    this.filesToUpload = [];
    this.allKeyWords = this.verifiedKeyWords;
    this.selectedKeywords = [];
    this.newKeywords = [];
    this.refreshDocuments.emit(true);
    this.sidebar.hide();
  }

  onNativeInputFileSelect($event: Event): void {
    this.filesToUpload = [];
    this.filesToUpload = Array.from(($event.target as HTMLInputElement).files);
    //Comprobamos la longitud de los ficheros
    const longNameFiles = this.filesToUpload.filter(f => f.name.length > 88);
    if (longNameFiles.length > 0) {
      this.errorService.show('', new Error('The name of the files are too long. Please, reduce the file name length and try it again'));
    }
  }

  get getFileName(): string {
    if(this.filesToUpload && this.filesToUpload.length > 0){
      return this.filesToUpload[0].name.toLowerCase();
    }
    else return '';
  }

  get isValid(): boolean {
    for (const p of this.documentProperties) {
      if (p.isMandatory) {
        const value = this.docItem[p.name];
        if (value == null || value === '') return false;
      }
    }
    return true;
  }

  get isSubmitDisabled(): boolean {
    if(this.controlSubmitButton) {
      if(!this.isValid || this.isUploadingDocument ||
        (!this.filesToUpload || this.filesToUpload.length === 0) &&
        (!this.linkAddress || this.linkAddress.length === 0)) return true;
      else return false
    }
    else {
      if(!this.isValid || this.isUploadingDocument) return true;
      else return false;
    }
  }

  get isSubmitDisabledforAccessTrends(): boolean{
    if(this.controlSubmitButton) {
      if(this.isUploadingDocument ||
        (!this.filesToUpload || this.filesToUpload.length === 0) &&
        (!this.linkAddress || this.linkAddress.length === 0)) return true;
      else return false
    }
    else {
      if(this.isUploadingDocument) return true;
      else return false;
    }
  }
}
